import React from 'react';
import Box from "@cloudscape-design/components/box";
import Container from "@cloudscape-design/components/container";
import Header from "@cloudscape-design/components/header";
import Link from "@cloudscape-design/components/link";
import StatusIndicator from "@cloudscape-design/components/status-indicator";

const ServiceHealth = () => {
  return (
    <Container
      header={
        <Header variant="h2">
          Service health
          <Link variant="info" href="#" style={{ marginLeft: '5px' }}>
            info
          </Link>
        </Header>
      }
    >
      <Box variant="awsui-key-label">Region</Box>
      <Box variant="p">N. Virginia (us-east-1)</Box>
      <Box variant="awsui-key-label" padding={{ top: 'l' }}>Status</Box>
      <StatusIndicator type="success">
        Service is operating normally
      </StatusIndicator>
    </Container>
  );
};

export default ServiceHealth;
